var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebaseAuthentication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.41 47.34a4 4 0 0 0-6.77-2.16L115.88 66 99.54 34.89a4 4 0 0 0-7.08 0l-8.93 17-22.4-41.77a4 4 0 0 0-7.48 1.28L32 150l57.9 32.46a12 12 0 0 0 11.7 0L160 150z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 56.9,
    y1: 102.54,
    x2: 48.9,
    y2: 98.36,
    gradientUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a52714",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 90.89,
    y1: 90.91,
    x2: 87.31,
    y2: 87.33,
    gradientUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a52714",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 27.188,
    y1: 40.281,
    x2: 160.875,
    y2: 173.968,
    gradientUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v192H0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 150L53.66 11.39a4 4 0 0 1 7.48-1.27l22.4 41.78 8.93-17a4 4 0 0 1 7.08 0L160 150z",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 9L0 0v192l32-42z",
    fill: "url(#b)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.83 96.01l-23.3-44.12L32 150z",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v192H0z",
    fill: "url(#c)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 150L143.41 47.34a4 4 0 0 0-6.77-2.16L32 150l57.9 32.47a12 12 0 0 0 11.7 0z",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.41 47.34a4 4 0 0 0-6.77-2.16L115.88 66 99.54 34.89a4 4 0 0 0-7.08 0l-8.93 17-22.4-41.77a4 4 0 0 0-7.48 1.28L32 150h-.08l.07.08.57.28L115.83 67l20.78-20.8a4 4 0 0 1 6.78 2.16l16.45 101.74.16-.1zM32.19 149.81L53.66 12.39a4 4 0 0 1 7.48-1.28l22.4 41.78 8.93-17a4 4 0 0 1 7.08 0l16 30.43z",
    fillOpacity: 0.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6 181.49a12 12 0 0 1-11.7 0l-57.76-32.4-.14.91 57.9 32.46a12 12 0 0 0 11.7 0L160 150l-.15-.92z",
    fill: "#a52714",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.41 47.34a4 4 0 0 0-6.77-2.16L115.88 66 99.54 34.89a4 4 0 0 0-7.08 0l-8.93 17-22.4-41.77a4 4 0 0 0-7.48 1.28L32 150l57.9 32.46a12 12 0 0 0 11.7 0L160 150z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 144,
    r: 40,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 142c3.32 0 5.98-2.68 5.98-6s-2.66-6-5.98-6c-3.32 0-6 2.68-6 6s2.68 6 6 6zm-16 0c3.32 0 5.98-2.68 5.98-6s-2.66-6-5.98-6c-3.32 0-6 2.68-6 6s2.68 6 6 6zm0 4c-4.66 0-14 2.34-14 7v5h28v-5c0-4.66-9.34-7-14-7zm16 0c-.58 0-1.24.04-1.94.1 2.32 1.68 3.94 3.94 3.94 6.9v5h12v-5c0-4.66-9.34-7-14-7z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebaseAuthentication);
export default __webpack_public_path__ + "static/media/Firebase_Authentication.be16cc5d3ce9755c121026f305ed4b67.svg";
export { ForwardRef as ReactComponent };